import { configureStore } from '@reduxjs/toolkit'
import tctappstoreReducer from '../Features/tctappstoreslice'


export default configureStore({
  reducer: {
    tctappstore: tctappstoreReducer,
  },
})